import {request} from '@/utils/request'

// p13用户验证
export function loginFromP13 (data) {
	return request ({
		url: '/oauth/process?func=loginFromP13',
		method: 'post',
		data
	})
}
//根据ticket获取用户信息
export function getUserInfoByTicket (data) {
	return request ({
		url: '/oauth/process?func=getUserInfoByTicket',
		method: 'post',
		data
	})
}
//登出
export function logoutFromP13 (data) {
  return request ({
    url: '/oauth/process?func=logoutFromP13',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/oauth.js